import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/teamStyle.js";

import happyDude from "assets/img/happydude.png";
import businessDude from "assets/img/business.png";
import capitanoDude from "assets/img/capitano.png";

const useStyles = makeStyles(styles);

export default function TeamSection() {
  const classes = useStyles();
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <h2 className={classes.title}>It&apos;s just me!</h2>
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card plain>
              <GridItem xs={6} sm={6} md={4} className={classes.itemGrid}>
                <img src={happyDude} alt="..." className={imageClasses} />
              </GridItem>
              <h4 className={classes.cardTitle}>
                Silas
                <br />
                <small className={classes.smallTitle}>Creator</small>
              </h4>
              <CardBody>
                <p className={classes.description}></p>
              </CardBody>
              <CardFooter className={classes.justifyCenter}></CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
